module.exports = __webpack_public_path__ + "static/img/404.47e45d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PageCommon/img/404.png
// module id = NDQL
// module chunks = 105